import styled from 'styled-components';

import { media } from 'styles/utils';
import { Heading, Paragraph } from 'common/typography';

export const WelcomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 32px;

  ${media.tablet`
    max-width: 40rem;
    margin-bottom: 0;
  `}
`;

export const StyledHeading = styled(Heading)`
  font-size: 36px;
  line-height: 49px;
  margin: 0 0 28px 0;
  font-weight: 900;

  ${media.tablet`
    max-width: 576px;
    margin: 0 0 32px 0;
    font-size: 44px;
    line-height: 60px;
  `}
`;

export const StyledParagraph = styled(Paragraph)`
  line-height: 160%;
  max-width: 480px;
`;
